import urlResolver from 'admin/utils/URLResolver';
import useSWR from 'swr';
import { Task } from 'edrolo/domains/coursePortal/types/Task';

export const useTasksStudent = () => {
  const url = urlResolver.reverse('api:student_tasks-list');

  const { data, mutate, error, isLoading } = useSWR<Task[]>(url);

  if (error) {
    console.error(error);
  }

  return {
    data,
    mutate,
    isLoading,
    error,
  };
};
